var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffad33;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.7,98.5c-6.6-1-13.1-2.5-19.6-3.9-4-.9-9.6-.9-11.6-5-.2-.5-.1-1,.3-1.3,3.4-3.1,8.9-.9,13-.2,6.2,1,12.4,2,18.6,3.4,4.4.9,4,7.7-.7,7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.5,34.1c-.8-6.6-1.1-13.3-1.5-19.9-.2-4.1-1.7-9.5,1.7-12.5.4-.3,1-.3,1.4,0,3.9,2.4,3.3,8.3,3.8,12.5.7,6.2,1.5,12.5,1.8,18.8,0,4.4-6.6,5.8-7.2,1.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.8,38.1c5.7,6.1,12,11.9,16.7,18.8,1.8,2.6-2.1,6.2-4.5,4.3-6.6-5.2-12-11.9-17.5-18.2-5.4-6.2-11.5-12.4-15.3-19.8-.9-1.8,1.2-4.2,3.1-2.9,6.7,5,11.9,11.7,17.5,17.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShin);
export default __webpack_public_path__ + "static/media/shin.aecf958ae3f5cbe0c438a6ea2f3b9bcb.svg";
export { ForwardRef as ReactComponent };